export default __webpack_public_path__ + "static/media/colorWhatIfLow.00740799.svg";